import { Cabinet } from '../entities/Cabinet';
import { checkAndUpdatePlates } from './platesManager';
import { checkAndUpdateCrossPieces } from './crossPiecesManager';
import { checkAndUpdateInterShelves } from './intermediateShelfManager';
import { checkAndUpdateWheelPane } from './platesManager';

export function checkAndUpdate(cabinet: Cabinet, update = true): void {
  checkAndUpdateCrossPieces(cabinet, update);
  checkAndUpdatePlates(cabinet, update);
  checkAndUpdateInterShelves(cabinet, update);
  checkAndUpdateWheelPane(cabinet, update);
}
